export default __webpack_public_path__ + "static/media/IMG-20250105-WA0018.31122121.jpg";